import NumberInput from "app/components/NumberInput/NumberInput";
import SegmentedControl, {
  SegmentedTabType,
} from "app/components/SegmentedControl/SegmentedControl";
import { LossLimitsType } from "app/types/userType";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import "./LossLimits.scss";

export const LimitsTimePeriods = {
  DAILY: "DAILY",
  WEEKLY: "WEEKLY",
  MONTHLY: "MONTHLY",
};

type Props = {
  onLimitChange: (id: string, limit: LossLimitsType) => void;
  limit: LossLimitsType;
  handleErrorChange: (id: string, value: boolean) => void;
};

const LossLimits = (props: Props) => {
  const { onLimitChange, limit } = props;
  const [tab, setTabValue] = useState(LimitsTimePeriods.DAILY);

  const resetLimits = () => ({
    lossLimitOneDay: null,
    lossLimitSevenDays: null,
    lossLimitThirtyDays: null,
  });

  const setTab = (tabType: string) => {
    if (tab === tabType) {
      return null;
    }
    setTabValue(tabType);
    onLimitChange("lossLimits", resetLimits());
  };

  const handleInputChange = (newLimitValue: string | number | null) => {
    // First reset any values, then set the new value for the appropriate time period
    const updatedLimit: LossLimitsType = {
      ...resetLimits(),
      [tab === LimitsTimePeriods.DAILY
        ? "lossLimitOneDay"
        : tab === LimitsTimePeriods.WEEKLY
        ? "lossLimitSevenDays"
        : "lossLimitThirtyDays"]: newLimitValue,
    };
    onLimitChange("lossLimits", updatedLimit);
  };

  const tabs: SegmentedTabType[] = [
    {
      title: (
        <FormattedMessage
          id="home-register-limits-daily"
          defaultMessage={"Daily"}
        />
      ),
      callback: () => setTab(LimitsTimePeriods.DAILY),
      isActive: tab === LimitsTimePeriods.DAILY,
    },
    {
      title: (
        <FormattedMessage
          id="home-register-limits-weekly"
          defaultMessage={"Weekly"}
        />
      ),
      callback: () => setTab(LimitsTimePeriods.WEEKLY),
      isActive: tab === LimitsTimePeriods.WEEKLY,
    },
    {
      title: (
        <FormattedMessage
          tagName="span"
          id="home-register-limits-monthly"
          defaultMessage={"Monthly"}
        />
      ),
      callback: () => setTab(LimitsTimePeriods.MONTHLY),
      isActive: tab === LimitsTimePeriods.MONTHLY,
    },
  ];

  let currentLimitValue: number | null = null;
  if (limit) {
    if (tab === LimitsTimePeriods.DAILY) {
      currentLimitValue = limit.lossLimitOneDay ?? null;
    } else if (tab === LimitsTimePeriods.WEEKLY) {
      currentLimitValue = limit.lossLimitSevenDays ?? null;
    } else if (tab === LimitsTimePeriods.MONTHLY) {
      currentLimitValue = limit.lossLimitThirtyDays ?? null;
    }
  }

  return (
    <div className="loss-limit-container">
      <div className="loss-limit-container__title">
        <FormattedMessage
          id="home-register-limits-set-loss"
          defaultMessage="Set Your Loss Limit"
        />
      </div>
      <SegmentedControl tabs={tabs} tabTypes={LimitsTimePeriods} />
      <div className="loss-limit__input">
        <label
          className="text-input-container__input-label"
          htmlFor="limit-input"
        >
          <FormattedMessage
            id="home-register-limits-loss"
            defaultMessage={"Loss Limit"}
          />
        </label>
        <NumberInput
          onUpdate={newLimitValue => {
            handleInputChange(newLimitValue);
          }}
          value={currentLimitValue}
          handleErrorChange={props.handleErrorChange}
          disabled={false}
        />
      </div>
    </div>
  );
};

export default LossLimits;
